








































































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '@/CommonFeature/components/ApiAccessBase.vue';
import router from '@/router';
// 共通モジュール
import { supervisingModule } from '@/store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { traderInfoModule } from '../store/modules/TraderInfo';
import { CustomScreenName } from '../fixed/CustomScreenName';
import { Constants } from '@/CommonUtils/fixed/Constants';
import { CustomConstants } from '../fixed/CustomConstants';
// 拡張コンポーネント
import TraderInfoGroup from '@/Uketsuke/custom/components/TraderInfoGroup.vue';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);
Vue.component('traderInfoGroup', TraderInfoGroup);

@Component
export default class TraderInfo extends ApiAccessBase {
  // 拡張パネルの設定（検索条件）
  private exPanel: number[] = [];
  private exPanelBk: number[] = [];

  private variableColNames: string[] = [];
  private GROUP_LAYOUT_ARRAY: string = Constants.GROUP_LAYOUT_ARRAY;
  private GROUP_LAYOUT_LIST: string = Constants.GROUP_LAYOUT_LIST;

  private created() {
    // モジュール内のキーを使ってデータ取得
    // getInit呼び出し
    this.apiAccess(
      CustomConstants.TRADER_INFO_INIT_PATH + traderInfoModule.GET_TRADER_PATH,
      Constants.API_METHOD_GET,
      false,
      false,
    ).then((result) => {
      if ((result) === Constants.API_RESULT_SUCCES) {
        this.setAllVariablecolsState();
        let panelIndex = 0;
        for (const variablecol of Object.keys(this.variablecols)) {
          // パネル設定全オープン
          this.exPanel.push(panelIndex);
          panelIndex++;
          this.variableColNames.push(variablecol);
        }
        this.exPanelBk = this.exPanel.concat();
      }
    });
  }

  private exPanelAllClose() {
    this.exPanel = [];
  }
  private exPanelAllOpen() {
    this.exPanel = this.exPanelBk.concat();
  }
  private returnPrevious() {
    router.push({ name: CustomScreenName.TRADER_INFO_SEARCH });
  }
}
